import createLumirIcon from "../create-lumir-icon";

const ChevronLeft = createLumirIcon("ChevronLeft", [
  [
    "path",
    {
      key: "chevron-left",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor",
      d: "M12.4833 18C12.1339 18 11.7859 17.8368 11.5245 17.512L6.37348 11.1122C5.86944 10.4834 5.8761 9.48661 6.39081 8.86902L11.7246 2.46918C12.2446 1.8436 13.0887 1.8436 13.61 2.46918C14.1301 3.09476 14.1301 4.10594 13.61 4.73152L9.20303 10.0194L13.442 15.2881C13.9541 15.9248 13.9394 16.9376 13.41 17.5504C13.15 17.8512 12.8166 18 12.4833 18Z",
    },
  ],
]);

export default ChevronLeft;
